import Vue from 'vue'
import Router from 'vue-router'
import MenuView from '@/views/common/MenuView'
import PageView from '@/views/common/PageView'
import LoginView from '@/views/login/Common'
import DataView from '@/views/datav/index'
import AddStudy from '@/views/learning/add-earningHome'
import Data1 from '@/views/login/Data'
// import PkSettingView from '@/views/pk/PkSetting'
import EmptyPageView from '@/views/common/EmptyPageView'
import HomePageView from '@/views/HomePage'
import CarLocationDetails from '@/views/carlocation/carLocation2'
import RecordView  from '@/views/xunjian/Record'
import Town from '@/views/bigdata/town/index'
import County from '@/views/bigdata/county/index'
import Maintain from '@/views/maintain/maintain'
import LuZhuanZhen from '@/views/zhuluzhen/member'
import wasteWater from '@/views/sewage/sewageHome'
import zqgbHome from '@/views/sys/zqgb'
import db from 'utils/localstorage'
import request from 'utils/request'

Vue.use(Router)
const originalPush=Router.prototype.push

Router.prototype.push=function push(location){
  return originalPush.call(this,location).catch(err=>err)
}
let constRouter = [
  {
    path: '/login',
    name: '登录页',
    component: LoginView,
    // redirect: '/maintain'
  },
  {
    path: '/data',
    name: 'DataView',
    component: DataView
  },
  {
    path: '/data1',
    name: 'DataView',
    component: Data1
  },
  {
    path: '/record',
    name: 'RecordView',
    component: RecordView
  },
  {
    path: '/page',
    name: 'pageView',
    component: MenuView,
    children:[
      {
        path: 'carLocationDetails',
        name: 'carLocationDetails',
        component: CarLocationDetails
      },
    ]
  },

  {
    path: '/',
    name: '首页',
    redirect: '/home'
  },
  // {
  //   path: '/home',
  //   name: '首页',
  //   redirect: '/maintain'
  // },
  {
    path: '/add-earningHome',
    name:'AddStudy',
    component: AddStudy
  },
  {
    path: '/town',
    name:'Town',
    component: Town
  },
  {
    path: '/county',
    name:'County',
    component: County
  },
  {
    path: '/maintain',
    name:'Maintain',
    component: Maintain
  },
]

let router = new Router({
  routes: constRouter
})

const whiteList = ['/login', '/data','/data1','/maintain']

const isMaintain = true;

let asyncRouter

// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) !== -1) {
    next({to, replace: true})
    return
  }
  let token = db.get('USER_TOKEN')
  let user = db.get('USER')
  let userRouter = get('USER_ROUTER')
  if (token.length && user) {
    if (!asyncRouter) {
      if (!userRouter) {
        request.get(`menu/${user.username}`).then((res) => {
          console.log(res.data, 'router-data')
          asyncRouter = res.data
          save('USER_ROUTER', asyncRouter)
          go(to, next)
        })
      } else {
        asyncRouter = userRouter
        go(to, next)
      }
    } else {
      next()
    }
  } else {
    next('/login')
  }
})

function go (to, next) {
  asyncRouter = filterAsyncRouter(asyncRouter)
  router.addRoutes(asyncRouter)
  next({...to, replace: true})
}

function save (name, data) {
  localStorage.setItem(name, JSON.stringify(data))
}

function get (name) {
  return JSON.parse(localStorage.getItem(name))
}

function filterAsyncRouter (routes) {
  return routes.filter((route) => {
    let component = route.component
    if (component) {
      switch (route.component) {
        case 'MenuView':
          route.component = MenuView
          break
        case 'PageView':
          route.component = PageView
          break
        case 'EmptyPageView':
          route.component = EmptyPageView
          break
        case 'HomePageView':
          route.component = HomePageView
          break
        case 'HomePageView2':
          route.component = RecordView
          break
        case 'HomePageTown':
          route.component = Town
          break
        case 'HomePageCounty':
          route.component = County
          break
        case 'LuZhuanZhenHomePage':
          route.component = LuZhuanZhen
          break
        case 'WasteWaterHomePage':
          route.component = wasteWater
          break
        case 'zqgbHomePage':
          route.component = zqgbHome
          break
        default:
          route.component = view(component)
      }
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children)
      }
      return true
    }
  })
}

function view (path) {
  return function (resolve) {
    if (path === '/integral/CategoryManager') {
      path = 'integral/CategoryManager'
    }
    import(`@/views/${path}.vue`).then(mod => {
      resolve(mod)
    })
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js